import { render, staticRenderFns } from "./modalEditAddress.vue?vue&type=template&id=5e78ef2c&"
import script from "./modalEditAddress.vue?vue&type=script&lang=js&"
export * from "./modalEditAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports